import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("<PollParticipation @poll={{@model}} />",{ moduleName: "@croodle/client/templates/poll/participation.hbs" })